import React from "react";
import '../HighConvertingSection/HighConvertingSection.css';
import './MobileBankingAppSection.css';
import mainImg from './images/mainImg.png';
import imageOne from './images/2.png';
import quickActionsImg from './images/quick_action.png';
import chunkingImg from './images/chunking.png';
import googleImg from './images/google-logo.png';
import readingImg from './images/reading (1).png';
import sizeProximity from './images/sizeProximity.png';
import davidImg from './images/David.png';
import sarahImg from './images/sarah.png';
import emilyImg from './images/emily.png';
import miaImg from './images/mia.png';
import zoeyImg from './images/zoey.png';
import maxImg from './images/max.png';
import davidCard from './images/David_Card.png';
import emilyCard from './images/emily_card.png';
import sarahCard from './images/sarah_card.png';
import miaCard from './images/mia_card.png';
import zoeyCard from './images/zoey_card.png';
import maxCard from './images/max_card.png';

import sarahPersona from './images/sarah_persona.png';
import davidPersona from './images/david_persona.png';
import emilyPersona from './images/emily_persona.png';
import miaPersona from './images/mia_persona.png';
import zoeyPersona from './images/zoey_persona.png';
import maxPersona from './images/max_persona.png';

import c1Img from './images/c1.png';
import c2Img from './images/c2.png';
import c3Img from './images/c3.png';

export default function MobileBankingAppSection(){
    return(
        <div className="container-fluid MobileBankingAppSection mobile_banking_app_section_parent_wrapper py-3">
            <div className="container mobile_banking_app_section_child_wrapper py-3">
                <div className="bg-success case_study_bg py-4 px-4">
                    <h3 className="font-weight-bolder case-study-heading text-white mt-3">
                        Effective Intuitive Banking App
                    </h3>
                    <div className="col-12 col-sm-12 col-md-7 mt-5">
                        <img src={mainImg} alt="" className="img-fluid mx-auto" />
                    </div>
                </div>
                <h3 className="background_title font-weight-bolder mt-5">
                    Background
                </h3>
                <p className="case_study_description mt-4">
                    In an era where digital banking has become the norm, user experience design (UXD) plays a crucial role in customer satisfaction and retention. 
                    Mobile banking applications are the primary touchpoint between banks and their customers, providing a platform for a wide array of financial services. 
                    An effective mobile banking app is not just about allowing users to conduct transactions but also about offering a seamless, intuitive, and secure user experience.
                </p>
                <h3 className="background_title font-weight-bolder mt-5">
                    Problem
                </h3>
                <p className="case_study_description mt-4">
                    Many mobile banking applications suffer from a lack of intuitive design, leading to user frustration and inefficiency. The core issues identified include:
                </p>
                <div className="row mt-4 gx-4">
                    <div className="col-12 col-sm-12 col-md-4">
                        <div className="card-img-top mobile_img">
                            <img style={{height:70}} className="" src="data:image/png;base64,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"></img>
                        </div>
                        <div className="">
                            <p className="case_sub_title">
                                Cognitive Load & Information Overload
                            </p>
                            <p className="case_study_description mt-3">
                              Users are often bombarded with too much information at once, making it difficult to find what they need quickly.
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4">
                        <div className="card-img-top mobile_img">
                            <img style={{height:70}} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABIUlEQVR4nO2YwW3CUAyGv1NmaBmldIKWeZo7ahu6U2GahAFIL5yMIrkSQoKGxGBH9Sf5Zv/5Hb/kSYYkSZJk4hTAF7AF5I9ogEprwrHq0cBpfBKQRs099cidH00mHKJxq/y7kY1EQ/JoBf1rzXvkPmtuTUCqAffIBwEptJnfyVyKWpsIebNP7r64lmwkGmEmsgDWwM+Av9LYaPXZr2ObeHcwL2diOWYSncAeeANmDkdrBpTqodN4GSKy0eJOyPsbKVXje0hxq8WPARp5UI2dl4EQOuJt4IRsRLzf5L+dSGG0WHPXWRkt1tx1GqPFmruOXHmGz+W764i3ASsd8TZgpSPeBqx0xNuAlU5jtFhz16mMFmvuOoXRYi2aTpIkScLNOQAzAq1JG/omlQAAAABJRU5ErkJggg=="/>
                        </div>
                        <div className="">
                            <p className="case_sub_title">
                                Poor Visual Hierarchy
                            </p>
                            <p className="case_study_description mt-3">
                                The lack of clear and concise visual hierarchy leads to confusion about 
                                the importance and order of actions users should take.
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4">
                        <div className="card-img-top mobile_img">
                            <img style={{height:70}} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAG6ElEQVR4nO2d/U9TVxjHr9l+MPHX+Tfs5Zdl0180zrCMbSaL4pbMiC7TqGAypbultOCoFJBm021GMGXZdL5MN98CA40voEa0rTroNpw6XDZ+GTK6GLHnxF/k7buc2xYoUFfKfTktz5N8w+XewyXnfHie59ynh3sUhYyMjIyMjIyMjIyMTHLjnL/GGDvOGOtljA1xzqGHGGPDjLF/GGMnOOdLre6n9AbgWcbYV3oBSAFQPYBnrO63tGYmDD4GxWd1v6UNU2bD4GNaYnX/pTORM6wC8uDBg1NW9186Ewl84kD5ahuQu9SOnEU2XSTu5atrmATk0aNHTzjn3YyxQQu9dLqhdogxdp8xdswQD59qNqUnjLjeXFps+WAaBMgnJkW6AZnql+gNIy4uwQAaoZ6engOmAUHQPiPNBiCcc9TW1m5SFGUOAeFyKBQKBRRFWWgukFv1QO+vQE8I+OULXTzEp/MEwmglm6CEw+GHiqLkK4oy3yQgDqDvDhD+I6qedl2A5GYQjKdNUCKRyHAMyGJzgFwvAcJdY0Du/6wLkBwJBjgdTdWXGJCVJnmIHbi9H+j7Hej9DeisnRLAk6CK4TSBqFcgtVIEsto8IJqnOKJKAqPBX4Bz/kIMBtXZCiTfXCBJNBBQ0RQoQL1/g6amQKEGiIBYAGQwaEeTfwxGXKf8BQTEKCAjgWQwVDQHCifBiIs8xAAgF5rXof7EKrCrRQkwhoIqTvuTwyAgBgA537wOjoPLNXm+W4mu1s0ajOGgirOBzU+FMV0gORkky5J6HEZcJQeX48zpD3HW//8wUgGSmyUPhpYC2XVubUowUgHiq8u80kn93kY5gERhrEkZRipAeBbJVCACxs5peAYBSdPMTLRcgr9i6T2EMTYw8cb0ES63NGT9aXSifVoi5FkkvYActbojPEukC5DHjx+/zBgbsbozPAukC5BIJLLQ6o7wLBGFLD5bkrpJKxd5lommvTw7PWTSjenBkMsLZLqlEiqdKNYA+aZ1I1o8RWjx2LRjAsKt9ZBrW+2493qZpqs2Nf3ye23mld+TTVBMB3K4sRAHzm7SjjvWlIwCEcfinLgm2tAHVCYAaS23aYPf9UYZmndvQZuqjgJpK1a1c+Ka+P6i25ayh+RI8Fefjiz3kLvLSkcBxAc9ftziLkq4dmeZixY5GA0kWFicMOh33y7Fvc+qNd19KxGWaEurTgwG8vXljTj9+Vbc3ODArTwnuit3AD1eTd2eHejMc+HGhmKtjWhLQEwAcmbXFtxY78CtFS50e2oSgIhz4ppoQ0BMAHK9YIqQtbMaXSJkiWMKWbA0qbe6Px6X1G0TknophSyjgcRnVWJq27T7o4Rp7xV74rS3laa9Zj0YFuDbc8kfDMW1Q/RgmG9N6aRofOnETisXucW1LFFQvFBZhAuVNuy7GPUaqvYqVH7nEnwwZWrpxOj6D88i0Ue4PDs9hFYucrmA0MpFLhEQWrnI5QpZtHKRywWEQhaXDgitXOQSAaF/2OHSecikG9ODIZcXyPPeyzMSPambCGRd1UlUVBwiIFwCD3mh5hI6t3nx0FWOV7ytaXuIj1Yupg8kVObFQbcP71U1oqjye8Dp1LSrYj/eqW7Gvu31+Gnbp9MCkptBy0ileLXG+ME9WV47CmHI6QJcTk2DrtLR8wfcvmkByZFggPWqXJsOZHPl8ejAlzmBIw6gzQ747cApB+COAnm36se0gagSvMZP+lf8xQf2Re9lODxHokAEjIkvM2sqxoDTha2VP2htCYiBQFyeI/irtDIKQ4SptiSv+6so0dqItuJnyEMMArK94hD+Lq0YA3ItCZCqaNgSbcXPEBADQ9ZL3kv4xHM4CkXkjIkwztsx4HJpYU20pZBlQlIvjCd1kcCbihNgoDoarlZUN1FSNwvIcXfd6PR2WHytcAJVJRgWYSx2fr+7nqa9ZgG5XVaDY+V1WFPdgGLP0VEIX27fh/erG3G0fC86y7yz8sEwMvYyfutKJ3e21Wilk1drWtIvndRl3j99TvWqqb6+voeWV3vXU3ER8TFrb28PmPIyfiq/85SkqqonBiTPUCB6iqfYuUxTW1tby7hwtWhGQGjbPD5jGPPmzftgHJD5+m8sadI7F/v7+wd6e3v/jUQiuu1MbbTEbEokcLEJmM1mi4epuBbMCEYMyDGrOtfR0XF9QocyWQv02jZviQSJcJWiKMtjM5T8DNHqWAIXm4A9p+hpYvtQixPhYl07lOkm9nIV24eaAYIxNiJgzJ07d61uiTBbbc+ePRtDoVBQJC2RvPSCEIlERsLhcL/IGePClH6JMIttTmz70MxKhLPA5sfiep7OiXZ1bONFcW8KU2RkZGRkZGRkZMrM7T+aCFrnUkJobwAAAABJRU5ErkJggg=="></img>
                        </div>
                        <div className="">
                            <p className="case_sub_title">
                                Inadequate Content Strategy
                            </p>
                            <p className="case_study_description mt-3">
                                The information architecture is not well-organized, with essential actions being obscured by less critical information or promotional content.
                            </p>
                        </div>
                    </div>
                </div>
                <h3 className="background_title font-weight-bolder mt-5">
                    What is Cognitive Load?
                </h3>
                <p className="case_study_description mt-2">
                    Cognitive Load refers to the amount of mental effort required by a user to operate and navigate an interface                
                </p>
                <h3 className="background_title font-weight-bolder mt-3">
                    What is Information Overload?
                </h3>
                <p className="case_study_description mt-2">
                    Information Overload is when a user is presented with too much information at once, making it difficult to make decisions or find what they need                </p>
                <h3 className="background_title font-weight-bolder mt-3">
                    Objective
                </h3>
                <p className="case_study_description mt-4">
                    The primary objective of this case study is to design the mobile banking application to :
                </p>
                <ul className="case_study_list_wrapper">
                    <li className="mt-2 case_list">
                        <b>Enhance User Efficiency</b>: Design the app's interface to enable customers to complete their desired tasks as quickly and effortlessly as possible.
                    </li>
                    <li className="mt-2 case_list">
                        <b>Minimize Cognitive load to enhance user experience</b> : design the app's interface 
                        to be as simple and intuitive so the users don't have to spend much time trying to undertand it
                    </li>
                    <li className="mt-2 case_list">
                        <b>
                            Reduce Information Overload 
                        </b> &nbsp;
                        The Goal is to prioritize content by highlighting & presenting only the most important information or actions 
                    </li>
                    <li className="mt-2 case_list">
                        <b>Improve Visual Hierarchy</b> : Establish a clear visual hierarchy that naturally guides users through their banking tasks.
                    </li>
                    <li className="mt-2 case_list">
                        <b>Develop a Strong Content Strategy </b>: Reorganize the app's content to prioritize user goals and typical banking tasks over promotional material.
                    </li>
                </ul>
                <h3 className="background_title font-weight-bolder mt-5">
                    The Solution
                </h3>
                <p className="case_study_description mt-4">
                    Based on the information and data I gathered from the textbook/internet research and UX research 
                    I designed the mobile app in a way that adderss cognitive load and information overload by 
                    introducing UI elements related to cognitive load + information overload & help us eliminate them , 
                </p>
                <div className="row custom-row gx-4 gy-3 mt-5 py-4">
                    <div className="col-12">
                        <h5 className="problem_heading">
                            To reduce Cognitive Load + Information Overload I incorporated the following UI element
                        </h5>
                    </div>
                    <div className="col-12 col-sm-12 col-md-5 custom-col">
                        <img src={imageOne} style={{marginTop:"-9vh"}} alt="" className="img-fluid mx-auto d-flex" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-7 custom-col">
                        <img src={quickActionsImg} alt="" className="img-fluid mx-auto mt-4 d-none" />
                        <h5 className="mt-4" style={{fontWeight:900}}>
                            Cognitive Load Solution
                        </h5>
                        <h6 className="problem_heading mt-4">
                            Clear Labels & Iconography (Section 1)
                        </h6>
                        <ul className="case_study_list_wrapper mt-3">
                            <li className="solution_description">
                                Large intuitive icons that suggest Interactive Affordance
                            </li>
                            <li className="solution_description">
                                Clear Action Orientated Labels with constrast e.g
                                "Quick Actions "+ "Send Money" , instructing users what to do &nbsp;
                                <b>
                                    <i>
                                        Verbal/textual affordance
                                    </i>
                                </b>
                            </li>
                        </ul>
                        <h6 className="problem_heading mt-2">
                            Clear Information Visual Hieriechy
                        </h6>
                        <ul className="case_study_list_wrapper mt-2">
                            <li className="solution_description">
                                I displayed the account balance with a large front and contrasting color
                                making it visible to users without having to search for it reducing cognitive 
                                strain
                            </li>
                        </ul>
                        <h6 className="problem_heading mt-2">
                            Affordance (Section 2)
                        </h6>
                        <ul className="case_study_list_wrapper mt-2">
                            <li className="solution_description">
                                I incorporated 
                                Interactive elements like buttons in such a way that suggest they can be pressed to perform an action
                                by applying labelling that is clear & have contrast + iconography to them
                            </li>
                        </ul>
                        <h6 className="problem_heading mt-2">
                            Information Chunking
                        </h6>
                        <ul className="case_study_list_wrapper mt-2">
                            <li className="solution_description">
                                I organized information into logical relatable digestible sections eg by
                                Section Labelling  & 
                                Incorpotating Accordions to prevent overwhelming user with too much information at first glance that may 
                                confuse them
                            </li>
                        </ul>
                    </div>
                    

                    <div className="col-12 col-sm-12 col-md-5 custom-col">
                        <img src={imageOne} style={{marginTop:"-10vh"}} alt="" className="img-fluid mx-auto d-flex" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-7 custom-col">
                        <img src={quickActionsImg} alt="" className="img-fluid mx-auto mt-4 d-none" />
                        <h5 className="mt-4" style={{fontWeight:900}}>
                            Information Overload Solution
                        </h5>
                        <h6 className="problem_heading mt-4">
                            Accordions/collapsable sections
                        </h6>
                        <ul className="case_study_list_wrapper mt-3">
                            <li className="solution_description">
                                I incorporated accordion section to avoid bombading users with a lot of information
                                at first glance providing only the amount of neccesary information needed
                                while indicating to them there is more information available to them. &nbsp;
                                <i><b>Progressive Disclosure Technique</b></i>
                            </li>
                        </ul>
                        <h6 className="problem_heading mt-2">
                            Visual Separation and White Space
                        </h6>
                        <ul className="case_study_list_wrapper mt-2">
                            <li className="solution_description">
                                I incorporated ample white space which allows the eyes of users to rest and the brain to process 
                                each section independently without distraction. This separation & white space helps in reducing cognitive 
                                strain as the user interacts with the app.
                            </li>
                        </ul>
                        <h6 className="problem_heading mt-2">
                            Progressive Disclosure
                        </h6>
                        <ul className="case_study_list_wrapper mt-2">
                            <li className="solution_description">
                                I incorporated information in such a way that  it is not all visible upfront.
                                Information is only available when the user need it. 
                                For instance, 
                                the details of "Buy Voucher & Prepaid" or "Pay Bills & Utilities" are hidden under accordion menus. 
                                This helps in ensuring that users are not bombarded with information they don’t need immediately
                            </li>
                        </ul>
                    </div>


                    <div className="col-12 col-sm-12 col-md-5 custom-col">
                        <img src={imageOne} style={{marginTop:"-10vh"}} alt="" className="img-fluid mx-auto d-flex" />
                    </div>
                    <div className="col-12 col-sm-12 col-md-7 custom-col">
                        <img src={quickActionsImg} alt="" className="img-fluid mx-auto mt-4 d-none" />
                        <h5 className="mt-4" style={{fontWeight:900}}>
                            Inadequate Content Strategy:Solution
                        </h5>
                        <h6 className="problem_heading mt-4">
                            Prioritized User Tasks
                        </h6>
                        <ul className="case_study_list_wrapper mt-3">
                            <li className="solution_description">
                                I incorporated sections like Quick Actions which have features
                                such as "Send Money" "Deposit Money"
                                as these are the tasks that users are to perform frequently, and 
                                placing them at the top of the app this aligns with the user primary needs.
                            </li>
                        </ul>
                        <h6 className="problem_heading mt-2">
                            Secondary Information
                        </h6>
                        <ul className="case_study_list_wrapper mt-2">
                            <li className="solution_description">
                                I placed secondary content and actions further down the screen. 
                                To ensures that while the offers are visible and accessible, they do not interfere with the primary primary banking tasks
                                that the users user often.
                            </li>
                        </ul>
                        <h6 className="problem_heading mt-2">
                            Clear Navigation
                        </h6>
                        <ul className="case_study_list_wrapper mt-2">
                            <li className="solution_description">
                                I incoporated  simple navigation bar with clearly labeled icons for "Home", "My Cards", "Recharge", and "Profile
                                making it easy for users to switch between different sections of the app without getting lost in a lot of options.
                            </li>
                        </ul>
                    </div>

                    <h3 className="background_title font-weight-bolder mt-5">
                        Approach of the case study
                    </h3>
                    <p className="case_study_description mt-3">
                        Because I knew the core issues and problems of the app I divided my case-study into 
                        two part
                    </p>
                    <p className="case_study_description">1. User Centered Research Approach</p>
                    <p className="case_study_description" style={{marginTop:"-2vh"}}>2. What I call Textbook/Internet Research</p>
                    <div className="col-12 col-sm-12 col-md-12 case_col">
                        <img src={googleImg} style={{height:60}} alt="" className="img-fluid mx-autp" />
                        <img src={readingImg} style={{height:60}} alt="" className="img-fluid mx-autp" />
                    </div>
                    <h5 className="problem_heading mt-4">
                        I began with Textbook/Internet comprehensive research 
                    </h5>
                    <p className="solution_description">
                        I began doing comprehensive textbook/internet research on how to design a User Experience that 
                        reduce or eliminate Cognitive Load, Information Overload and solve the inadequate content 
                        strategy and poor visual hierarchy problem. I researched the UI elements, strategies and techniques 
                        that can address all these issues.
                    </p>
                    <p className="case_study_description">
                        <i>
                            <b>
                                I begin most of my researches this way to know which parameters to use/check when conducting
                                User-Centered Research.
                            </b>
                        </i>
                    </p>
                    <h5 className="problem_heading mt-2" style={{fontSize:"20pt",color:"black"}}>
                        Discovered
                    </h5>
                    <h5 className="solution_description">
                        During my research I discovered that the key elements to designing a User Experience 
                        that reduce Cognitive Load is to use the following key elements and techniques
                    </h5>
                    <h5 className="discovery_heading mt-4">
                        Simplicity & Limiting Option
                    </h5>
                    <p className="case_study_description" style={{fontWeight:600,lineHeight:"16pt"}}>
                        A minimalistic design with a clean layout, avoiding clutter, using whitespace effectively, 
                        limiting the number of options or features visible at once, and avoiding excessive text or graphics
                        is always effective
                    </p>
                    <h5 className="discovery_heading mt-4">
                        Contrasting Typography + Large Icons
                    </h5>
                    <p className="case_study_description" style={{fontWeight:600,lineHeight:"16pt"}}>
                        Clear concise action orientated headings with high contrasting large typography 
                        paired with large affordance icons do a better job at telling & guiding the user on what 
                        to do straightway without them spending too much time trying to figure out what actions
                        they are supposed to take
                    </p>
                    <div className="col-12 col-sm-12 col-md-3">
                        <img src={quickActionsImg}  alt="" className="img-fluid mx-auto d-flex" />
                    </div>
                    <h6 className="discovery_heading mt-4">
                        Size Contrast & Proximity
                    </h6>
                    <p className="case_study_description" style={{fontWeight:600,lineHeight:"16pt"}}>
                        Larger elements are perceived as more important, and items placed closely together are seen as related, 
                        guiding user interaction accordingly.
                    </p>
                    <div className="col-12 col-sm-12 col-md-4">
                        <img src={sizeProximity}  alt="" className="img-fluid mx-auto d-flex" />
                    </div>
                    <h6 className="discovery_heading mt-3">
                        Chuncked Content
                    </h6>
                    <p className="case_study_description" style={{fontWeight:600,lineHeight:"16pt"}}>
                        Logically grouping elements using clear labelling,in a related and more manageable groups for easier consumption is effective
                        as it helps the users in processing and understanding the content better
                    </p>
                    <h6 className="discovery_heading mt-3">
                        Collapsable Sections(eg acccordions)
                    </h6>
                    <p className="case_study_description" style={{fontWeight:600,lineHeight:"16pt"}}>
                        Implimenting sections that are collapsable & can be expanded to display 
                        the information when the user need it are effective in reducing congnitive load
                    </p>
                    <h3 className="background_title font-weight-bolder mt-2">
                        User Centric Research
                    </h3>
                    <p className="case_study_description" style={{fontWeight:600,lineHeight:"16pt"}}>
                        After the textbook/internet research I began User Centric Research 
                        to understand the needs, behaviors, preferences, and challenges of users 
                        and cross reference them with the general findings I found on the internet/textbook research 
                        to get insights that will guide me in designing a experience that 
                        effectively meet the users needs , challanges and expectations.
                    </p>
                    <p className="case_study_description" style={{fontWeight:600,lineHeight:"16pt"}}>
                        My approach to the User Centric Research
                    </p>
                    <ul className="case_study_description">
                        <h6 className="discovery_heading mt-2">
                            User Interviews
                        </h6>
                        <p className="case_study_description mt-3" style={{fontWeight:600,lineHeight:"16pt"}}>
                            conducted user interviews to get an insights on their 
                            needs , behaviors , preferences , challanges and goal
                        </p>
                        <h6 className="discovery_heading mt-3">
                            Google Review Analytics
                        </h6>
                        <p className="case_study_description mt-3" style={{fontWeight:600,lineHeight:"16pt"}}>
                            Did a review analytics to get an insights 
                            on users pain points and sentiments about the app as it helps in 
                            understanding which features/elements do they like or dislike, 
                            it helps with benchmarking & comparison 
                        </p>
                        <h6 className="discovery_heading mt-3">
                            User Personas
                        </h6>
                        <p className="case_study_description mt-3" style={{fontWeight:600,lineHeight:"16pt"}}>
                            I used the data and insights gathered through the researches to understand and
                            empathize with users during the design and development process
                        </p>
                        <h6 className="discovery_heading mt-3">
                            Card Sorting
                        </h6>
                        <p className="case_study_description mt-3" style={{fontWeight:600,lineHeight:"16pt"}}>
                            I used card sorting using the data and information gathered to summarise how users 
                            categorize their tasks and navigate through the applications
                        </p>
                    </ul>
                    <h6 className="discovery_heading mt-3">
                        Interview Phase
                    </h6>
                    <div className="row interviews_row gy-3 mt-3">
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <img src={davidCard} alt="" className="img-fluid mx-auto d-flex" />
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={emilyCard} alt="" className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={sarahCard} alt=""  className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={miaCard} alt=""  className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={zoeyCard} alt=""  className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={maxCard} alt=""  className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <h6 className="discovery_heading mt-5">
                        Persona Phase
                    </h6>
                    <div className="row persona_row gy-3">
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={davidPersona} alt="" className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={emilyPersona} alt="" className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={sarahPersona} alt="" className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={miaPersona} alt="" className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={zoeyPersona} alt="" className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-4">
                                <div className="card-img-top">
                                    <img src={maxPersona} alt="" className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <h6 className="discovery_heading mt-5">
                        Card Sorting
                    </h6>
                    <div className="row card_sorting_row gy-3">
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-3">
                                <div className="card-img-top">
                                    <img src={c1Img} alt="" className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-3">
                                <div className="card-img-top">
                                    <img src={c2Img} alt="" className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card py-3">
                                <div className="card-img-top">
                                    <img src={c3Img} alt="" className="img-fluid mx-auto d-flex" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}